import PaymentMethodSelector from "./PaymentMethodSelector";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const LastStep = () => {
  const { t, i18n } = useTranslation();
  const options = useMemo(
    () => [
      {
        value: "Credit Card",
        label: t("paymentState.creditCard"),
        icon: "/icons/Mastercard.svg",
        formSchema: {
          email: true,
          fullName: true,
          phoneNumber: true,
          creditCardForm: true,
        },
      },
      {
        value: "Donate in person",
        label: t("paymentState.payInPerson"),
        icon: "/icons/wallet.svg",
        formSchema: {
          email: true,
          fullName: true,
          phoneNumber: true,
          address: true,
          city: true,
          collection_date: false,
        },
      },
      {
        value: "Bank Installment",
        label: t("paymentState.bankInstallment"),
        icon: "/icons/bank.svg",
        formSchema: {},
      },
      {
        value: "Buy Now, Pay Later",
        label: t("paymentState.buyNowPayLater"),
        icon: "/icons/cash.svg",
        formSchema: {},
      },
    ],
    [i18n.language],
  );

  return (
    <>
      <div className="scrollbar-hide flex  w-full flex-grow flex-col gap-16 overflow-y-auto bg-background lg:max-w-[43rem]">
        <div className="flex flex-col gap-8">
          <div className="mt-8 flex w-full flex-col items-start justify-start border-t-2 border-[#CCC2BF]">
            <h3 className="pt-4 text-xl font-bold leading-[120%] sm:text-[32px] md:pt-8">
              {t("donationFlow.complete")}{" "}
            </h3>
          </div>
          <PaymentMethodSelector options={options} />
        </div>
      </div>
    </>
  );
};

export default LastStep;
